import React from 'react';
import PropTypes from 'prop-types';

import icons from '../../utils/webpack/iconList';

import styles from './Icon.scss';

const keys = icons.keys();

const Icon = ({ name, className, width, alt, ...rest }) => {
  const path = `./${name}.svg`;
  if (!keys.includes(path)) return null;
  const icon = icons(path);
  if (icon === null) return null;
  return (
    <div className={[styles.wrapper, className].join(' ')} {...rest}>
      <img src={icon} alt={alt} width={width} />
    </div>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.number,
  alt: PropTypes.string,
};
Icon.defaultProps = {
  className: null,
  width: null,
  alt: '',
};

export default Icon;
